const DEFAULT_ALL = {
	value: '',
	label: 'All - ทั้งหมด',
};

export default DEFAULT_ALL;
